package demos.buttons

import androidx.compose.animation.core.Spring
import androidx.compose.animation.core.animateDpAsState
import androidx.compose.animation.core.spring
import androidx.compose.foundation.border
import androidx.compose.foundation.gestures.detectTapGestures
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.offset
import androidx.compose.foundation.layout.padding
import androidx.compose.material.LocalContentColor
import androidx.compose.material.LocalTextStyle
import androidx.compose.material.Text
import androidx.compose.runtime.*
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.RectangleShape
import androidx.compose.ui.input.pointer.pointerInput
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp


const val STACKED_BUTTON = "3388b7b432f4d9e26a6bf01f552c0c8ba353155b66b0b17435ceafdb767cfce4"

@Composable
fun StackedButton() {
    var touched by remember { mutableStateOf(false) }
    val width = remember { 1.dp }
    val offset by animateDpAsState(
        if (touched) 0.dp else 3.dp,
        animationSpec = spring(
            dampingRatio = Spring.DampingRatioMediumBouncy,
            stiffness = Spring.StiffnessMedium
        )
    )

    Box(
        Modifier
            .pointerInput(Unit) {
                detectTapGestures(
                    onPress = {
                        touched = true
                        awaitRelease()
                        touched = false
                    }
                )
            }
            .border(width, Color.White.copy(alpha = .4f), RectangleShape)
            .offset(offset, -offset)
            .border(width, Color.White.copy(alpha = .8f), RectangleShape)
            .offset(offset, -offset)
            .border(width, Color.White, RectangleShape)
            .padding(horizontal = 24.dp, vertical = 8.dp)
    ) {
        CompositionLocalProvider(
            LocalContentColor provides Color.White,
            LocalTextStyle provides TextStyle(
                fontWeight = FontWeight.Thin,
            ),
        ) {
            Text(text = "Stacked Button")
        }
    }
}